<template>
  <div>
    <table>
      <tr>
        <td>
          <table>
            <tr>
              <td>
                <div style="float:left">
                  <h1>{{ translateWords.title }}</h1>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                  <table>
                    <tr>
                      <td>
                        <el-form-item :label="translateWords.SumStorage" prop="SumStorage">
                          <el-input :placeholder="translateWords.inputNum" v-model.number="ruleForm.SumStorage"></el-input>
                        </el-form-item>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <el-form-item :label="translateWords.ModelType" prop="ModelType">
                          <el-input :placeholder="translateWords.ModelType" v-model.number="ruleForm.ModelType"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr style="display:none;">
                      <td>
                        <el-form-item :label="translateWords.SupplierCode" prop="SupplierCode"><el-input v-model="ruleForm.SupplierCode"></el-input></el-form-item>
                      </td>
                    </tr>
                    <tr style="display:none;">
                      <td>
                        <el-form-item :label="translateWords.NewOrOld" prop="NewOrOld">
                          <el-select v-model="ruleForm.NewOrOld" :placeholder="translateWords.select" filterable style="width:400px">
                            <el-option v-for="item in NewOrOldoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <el-form-item :label="translateWords.room" prop="PositionId">
                          <el-select
                            v-model="ruleForm.PositionId"
                            :placeholder="translateWords.select"
                            filterable
                            @change="selectvalue(ruleForm.PositionId, 'PositionId')"
                            style="width:400px"
                          >
                            <el-option v-for="item in PositionIdoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <el-form-item :label="translateWords.RackId" prop="RackId">
                          <el-select v-model="ruleForm.RackId" :placeholder="translateWords.select" filterable @change="selectvalue(ruleForm.RackId, 'RackId')" style="width:400px">
                            <el-option v-for="item in RackIdoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <el-form-item :label="translateWords.Status" prop="Status">
                          <el-select v-model="ruleForm.Status" :placeholder="translateWords.select" filterable style="width:400px">
                            <el-option v-for="item in Statusoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                          </el-select>
                        </el-form-item>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <el-upload
                          action=""
                          class="upload-demo"
                          drag
                          :before-remove="beforeRemove"
                          :file-list="fileList"
                          list-type="picture"
                          :show-file-list="true"
                          :before-upload="beforeupload"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            {{ translateWords.uploadTip }}
                            <em>{{ translateWords.clickUpload }}</em>
                          </div>
                          <div class="el-upload__tip" slot="tip">{{ translateWords.uploadTipText }}</div>
                        </el-upload>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <el-form-item :label="translateWords.Remark" prop="Remark">
                          <el-input type="textarea" :rows="2" placeholder="" v-model="ruleForm.Remark"></el-input>
                        </el-form-item>
                      </td>
                    </tr>
                  </table>

                  <el-form-item style="float:left">
                    <el-button type="primary" @click="submitForm('ruleForm')">{{ translateWords.batchSave }}</el-button>
                    <el-button type="primary" @click="resetForm('ruleForm')">{{ translateWords.reset }}</el-button>
                  </el-form-item>
                </el-form>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import { importScript } from '../util/importScript';
  export default {
    name: 'PLAddSample',
    props: ['selval'],
    data() {
      return {
        PositionIdoptions: [],
        translateWords: {
          title: '批量录入样品',
          SumStorage: '入库数量',
          inputNum: '请输入数字',
          SupplierCode: '供应商代码',
          NewOrOld: '新旧品',
          select: '请选择',
          room: '位置',
          RackId: '货架-货架层',
          Status: '状态',
          uploadTip: '将文件拖到此处',
          clickUpload: '点击上传',
          uploadTipText: '可以上传多张照片，上传格式jpg/png文件，且不超过2M',
          Remark: '备注',
          batchSave: '批量保存',
          reset: '重置',
          message: '请选择网片信息',
          roomMessage: '请选择房间信息',
          selectRack: '请选择货架',
          countTip: '请输入不小于0的数量',
          saveSuccess: '保存成功 ',
          saveFail: '保存失败',
          getRackFail: '获取货架失败',
          picTip: '上传图片只能是jpg / png 格式!',
          picMaxSize: '图片最大2M!',
          uploadFail: '上传失败',
          ModelType: '型号',
        },
        ruleForm: {
          SumStorage: '',
          SupplierCode: '',
          NewOrOld: '',
          PositionId: '',
          RackId: '',
          Status: '',
          Sys_Guid: '',
          Remark: '',
          ModelType: '',
        },
        rules: {
          PositionId: [{ required: true, message: '请选择一个房间' }],
          //   SupplierCode:[
          //  { required: true, message: '输入供应商代码'}
          // ],
          //   NewOrOld:[
          //  { required: true, message: '请选择新旧品'}
          // ],
          Status: [{ required: true, message: '请选择状态' }],
          RackId: [{ required: true, message: '请选择货架' }],
          SumStorage: [
            { required: true, message: '请输入数量' },
            { type: 'number', message: '请输入不小于0的数量' },
          ],
        },
        uid: this.$route.query.uid,
        NewOrOldoptions: [],
        RackIdoptions: [],
        RackLayeroptions: [],
        Statusoptions: [],
        fileList: [],
        imgurls: '',
        lang: this.$route.query.lang,
      };
    },
    created: function() {
      //this.IsUseRackLayeroptions=this.$store.getters.getinitstatus;
      //this.IsUseRackoptions=this.$store.getters.getinitstatus;
      // this.Statusoptions=this.$store.getters.getinitstatus;
      //this.NewOrOldoptions=this.$store.getters.getneworold;
    },
    mounted() {
      var that = this;
      importScript(this.baseurl, () => {
        that.translateWord();
      });
    },
    methods: {
      translateWord() {
        var that = this;
        if (window.jsT) {
          for (const key in that.translateWords) {
            this.translateWords[key] = window.jsT.T(that.translateWords[key]);
          }

          this.rules = {
            PositionId: [{ required: true, message: window.jsT.T('请选择一个房间') }],
            Status: [{ required: true, message: window.jsT.T('请选择状态') }],
            RackId: [{ required: true, message: window.jsT.T('请选择货架') }],
            SumStorage: [
              { required: true, message: window.jsT.T('请输入入库数量') },
              { type: 'number', message: window.jsT.T('请输入大于0的数量') },
            ],
          };
        } else {
          console.log('翻译组件加载失败');
        }
      },
      getsampleinit() {
        var params = new URLSearchParams();
        params.append('lang', this.lang);
        params.append('uid', this.uid);
        params.append('cmd', 'InitSampleDrop');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            this.IsUseRackLayeroptions = res.data.Data.LoadDropStatus;
            this.IsUseRackoptions = res.data.Data.LoadDropStatus;
            this.Statusoptions = res.data.Data.LoadDropStatus;
            this.NewOrOldoptions = res.data.Data.LoadDropNewOrOld;
            this.PositionIdoptions = res.data.Data.LoadDropPosition;
          } else {
            alert(this.translateWords.getDataError + res.data.Message);
            // this.$message({
            //   message: res.data.Message,
            //   type: "error"
            // });
          }
        });
      },
      submitForm(formName) {
        if (this.selval == '[]') {
          alert(this.translateWords.message);
          return;
        }
        if (this.ruleForm.PositionId == '' || this.ruleForm.PositionId == '0') {
          alert(this.translateWords.roomMessage);
          return;
        }
        if (this.ruleForm.RackId == '' || this.ruleForm.RackId == '0') {
          alert(this.translateWords.selectRack);
          return;
        }

        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.ruleForm.SumStorage < 0) {
              alert(this.translateWords.countTip);
              return;
            }
            this.imgurls = '';
            let fd = new FormData();
            for (var key in this.ruleForm) {
              fd.append(key, this.ruleForm[key]);
            }
            fd.append('uid', this.uid);
            fd.append('Sys_Guid', '');
            fd.append('cmd', 'PLSaveSample');
            if (this.fileList.length > 0) {
              for (var i = 0; i < this.fileList.length; i++) {
                this.imgurls += this.fileList[i].url + ',';
              }
            }
            var that = this;
            fd.append('selectvalue', this.selval);
            fd.append('imgurls', this.imgurls);
            this.$http.post(this.actionurl, fd).then((res) => {
              if (res.data.Message == '') {
                //  this.$message({
                //   message: '保存成功',
                //   type: 'success'
                // });
                alert(that.translateWords.saveSuccess);
                this.resetForm('ruleForm');
                this.imgurls = '';
                this.fileList = [];
                this.$bus.$emit('closepage');
              } else {
                alert(that.translateWords.saveFail + ',' + res.data.Message);
                // this.$message({
                //   message: res.data.Message,
                //   type: "error"
                // });
              }
            });
          } else {
            return false;
          }
        });
      },
      selectvalue(val, type) {
        if (type == 'PositionId') {
          this.rackid = '';
          this.RackLayer = '';
          this.getrack(val);
        }
      },
      // reload()
      // {
      //       location.reload();
      // },
      guid() {
        function S4() {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
      },
      getrack(positionid) {
        var that = this;
        var params = new URLSearchParams();
        params.append('positionid', positionid);
        params.append('cmd', 'GetRackByPositionId');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            this.RackIdoptions = res.data.Data;
          } else {
            // this.$message({
            //   message: res.data.Message,
            //   type: "error"
            // });
            alert(that.translateWords.getRackFail + ',' + res.data.Message);
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      beforeupload(file) {
        var _this = this;
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'jpg' || testmsg === 'png' || testmsg === 'JPG' || testmsg === 'PNG';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!extension) {
          // _this.$message({
          //     message: "上传图片只能是jpg / png 格式!",
          //     type: "error"
          // });
          alert(this.translateWords.picTip);
          return false;
        }
        if (!isLt2M) {
          // _this.$message({
          //     message: "图片最大2M!",
          //     type: "error"
          // });
          alert(this.translateWords.picMaxSize);
          return false;
        }
        var that = this;
        let fd = new FormData();
        fd.append('file', file);
        fd.append('cmd', 'UpLoadFile');
        fd.append('filename', _this.guid() + '.' + testmsg);
        _this.$http.post(_this.actionurl, fd).then(function(res) {
          if (res.data.Message == '') {
            if (res.data.Data != null) {
              _this.fileList.push(res.data.Data);
            }
            // _this.$message({
            //     message: '上传成功',
            //     type: 'success'
            // });
            // alert("上传成功");
          } else {
            // _this.$message({
            //     message: res.data.Message,
            //     type: "error"
            // });
            alert(that.translateWords.uploadFail + ',' + res.data.Message);
          }
        });
      },
      beforeRemove(file) {
        var _this = this;
        var newlist = [];

        if (_this.fileList.length > 0) {
          for (var i = 0; i < _this.fileList.length; i++) {
            if (_this.fileList[i].name != file.name) {
              newlist.push(_this.fileList[i]);
            }
          }
          _this.fileList = [];
          _this.fileList = newlist;
        }
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/PLAddSample.vue